import { render, staticRenderFns } from "./TrendsReportManagement.vue?vue&type=template&id=d149b160&scoped=true"
import script from "./TrendsReportManagement.vue?vue&type=script&lang=js"
export * from "./TrendsReportManagement.vue?vue&type=script&lang=js"
import style0 from "./TrendsReportManagement.vue?vue&type=style&index=0&id=d149b160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d149b160",
  null
  
)

export default component.exports